import {
	SandboxTermsSchema,
	PrioritySchema,
	ImpliedConsentOptsSchema,
	IncomingPhoneNumberSchema,
	PackageSchema,
	PackagesSchema,
	MessagingDefaultsSchema,
	FeesV2Schema,
	FeesSchema,
	AddressSchema,
	OnboardingSchema,
	SubUserSchema,
	ProfileSchema,
	GoogleConfigSchema,
	MicrosoftConfigSchema,
	UserSchema,
	AgencySchema,
	IndustrySchema,
	AccountSubtypeSchema,
} from '@/schemas';
import { z } from 'zod';

export type SandboxTerms = z.infer<typeof SandboxTermsSchema>;
export type Priority = z.infer<typeof PrioritySchema>;
export type ImpliedConsentOpts = z.infer<typeof ImpliedConsentOptsSchema>;
export type IncomingPhoneNumber = z.infer<typeof IncomingPhoneNumberSchema>;
export type Package = z.infer<typeof PackageSchema>;
export type Packages = z.infer<typeof PackagesSchema>;
export type MessagingDefaults = z.infer<typeof MessagingDefaultsSchema>;
export type FeesV2 = z.infer<typeof FeesV2Schema>;
export type Fees = z.infer<typeof FeesSchema>;
export type Address = z.infer<typeof AddressSchema>;
export type Onboarding = z.infer<typeof OnboardingSchema>;
export type SubUser = z.infer<typeof SubUserSchema>;
export type Profile = z.infer<typeof ProfileSchema>;
export type GoogleConfig = z.infer<typeof GoogleConfigSchema>;
export type MicrosoftConfig = z.infer<typeof MicrosoftConfigSchema>;
export type User = z.infer<typeof UserSchema>;
export type Agency = z.infer<typeof AgencySchema>;
export type Industry = z.infer<typeof IndustrySchema>;
export type AccountSubtype = z.infer<typeof AccountSubtypeSchema>;

const IndustryLabels: Record<Industry, string> = {
	cannabis: 'Cannabis',
	brewery: 'Alcohol',
	coffee: 'Coffee',
	nightlife: 'Nightlife',
	political: 'Political',
	entertainment: 'Entertainment',
	firearms: 'Firearms',
	other: 'Other',
};

export const IndustryOptions = Object.entries(IndustryLabels).map(([value, label]) => ({ label, value })) as { label: string; value: Industry }[];

export const getIndustryLabel = (industry: Industry) => IndustryLabels[industry];

const AccountTypeLabels: Record<AccountSubtype, string> = {
	'vertical': 'Vertical',
	'retail': 'Retail',
	'brand': 'Brand',
	'sandbox': 'Sandbox',
	'freemium-vertical': 'Freemium Vertical',
	'freemium-retail': 'Freemium Retail',
	'freemium-brand': 'Freemium Brand',
};

export const AccountTypeOptions = Object.entries(AccountTypeLabels).map(([value, label]) => ({ label, value })) as { label: string; value: AccountSubtype }[];

export const getAccountTypeLabel = (accountType: AccountSubtype) => AccountTypeLabels[accountType];

const TimezoneLabels = {
	'Pacific/Honolulu': 'Hawaii Time',
	'America/Anchorage': 'Alaska Time',
	'America/Los_Angeles': 'Pacific Time',
	'America/Denver': 'Mountain Time',
	'America/Chicago': 'Central Time',
	'America/New_York': 'Eastern Time',
} as const;

export type Timezone = keyof typeof TimezoneLabels;

export const TimezoneOptions = Object.entries(TimezoneLabels).map(([value, label]) => ({ label, value })) as { label: string; value: Timezone }[];

export const getTimezoneLabel = (timezone: Timezone) => TimezoneLabels[timezone];
